export enum MediaTypesEnum {
  Audio = 'Audio',
  Video = 'Video',
  Image = 'Image',
  Document = 'Document'
}
